import { FunctionComponent } from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import { Location } from "@App/Pages/Common/Location";
import { useServiceFunnel } from "@App/hooks/useServiceFunnel";
import { Brands } from "@App/Pages/Common/Brands";
import { Generations } from "@App/Pages/Common/Generations";
import { Motorizations } from "@App/Pages/Common/Motorizations";
import { KeyNumber } from "@App/Pages/Common/KeyNumber";

/**
 * The funnel for the general catch-all "appointment" service.
 *
 * @constructor
 */
export const SparkPlugService: FunctionComponent = () => {
  const { navigateWithQuery } = useServiceFunnel("zuendkerzen-wechseln");

  return (
    <Routes>
      <Route
        path={"/"}
        element={
          <Brands
            headline={"Zündkerzen wechseln"}
            step={1}
            maxSteps={6}
            onKeyNumberLinkClick={() => navigateWithQuery("hsn-tsn")}
            onSubmit={() => navigateWithQuery(`modell`)}
          />
        }
      />
      <Route
        path={"/modell"}
        element={
          <Generations
            headline={"Zündkerzen wechseln"}
            step={2}
            maxSteps={6}
            onKeyNumberLinkClick={() => navigateWithQuery("hsn-tsn")}
            onSubmit={() => navigateWithQuery(`../motorisierung`, true)}
          />
        }
      />
      <Route
        path={"/motorisierung"}
        element={
          <Motorizations
            headline={"Zündkerzen wechseln"}
            step={3}
            maxSteps={6}
            onKeyNumberLinkClick={() => navigateWithQuery("hsn-tsn")}
            onSubmit={() => navigateWithQuery(`../ort`, true)}
          />
        }
      />
      <Route
        path={"/hsn-tsn"}
        element={
          <KeyNumber
            headline={"Zündkerzen wechseln"}
            step={3}
            maxSteps={6}
            onVehicletreeLinkClick={() => navigateWithQuery("./")}
            onSubmit={() => navigateWithQuery(`../ort`, true)}
          />
        }
      />
      <Route
        path={"/ort"}
        element={
          <Location
            headline={"Zündkerzen wechseln"}
            step={4}
            maxSteps={6}
            onSubmit={() => navigateWithQuery(`../werkstaetten`, true)}
          />
        }
      />
      {/* Redirect old links to funnel beginning */}
      <Route path={"/modellauswahl/*"} element={<Navigate to={"/zuendkerzen-wechseln"} />} />
    </Routes>
  );
};
